import { useState, useEffect } from 'react';
import { Info } from 'lucide-react';
import { HtmlContent } from '../components/RichTextEditor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Hakkimizda() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/site-settings`)
      .then(r => r.json())
      .then(data => { setSettings(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-amber-50">
        <div className="text-amber-700 text-lg animate-pulse">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl mb-4 shadow-lg">
            <Info className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Hakkımızda
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-amber-100 p-8">
          {settings?.about_content ? (
            <HtmlContent html={settings.about_content} className="text-amber-800" />
          ) : (
            <div className="text-center py-12 text-amber-500">
              <Info className="w-12 h-12 mx-auto mb-3 opacity-40" />
              <p className="text-lg">Hakkımızda bilgisi henüz eklenmemiş.</p>
              <p className="text-sm mt-1">Admin panelinden ekleyebilirsiniz.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
